import React, { Component } from 'react';
import resources from '../resources';
import StoreManager from '../appdata';
import languages from '../appdata/languages';


class MobileMenu extends Component {
  state = {
    expanded: null,
    selectedSubItem: '',
  };

  componentDidMount() {
    const path = window.location.pathname;
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].AppLanguage;

    const sectionPathMap = {
      [content.submenuAbout]: '/about',
      [content.submenuGame]: '/about/game',
      [content.submenuZalo]: '/about/zalo',
      [content.submenuZaloPay]: '/about/zalopay',
      [content.submenuDB]: '/about/digital-business',
      [content.submenuVNGPS]: '/about/people-strategy',
      [content.submenuVNGATCRS]: '/about/csr',
      [content.submenu2024Highlight]: '/strategy/highlight',
      [content.submenuCorporateStructure]: '/strategy/structure',
      [content.submenuMacroeconomicOverview]: '/strategy/macroeconomy',
      [content.submenuMDA]: '/report/mda',
      [content.submenuAnalysis]: '/report/analysis',
      [content.submenuAssessment]: '/report/assessment',
    };

    for (const [section, sectionPath] of Object.entries(sectionPathMap)) {
      if (path === sectionPath) {
        const expanded = this.findExpandedKey(section, content);
        this.setState({ expanded, selectedSubItem: section });
        return;
      }
    }

    if (path === '/') this.setState({ expanded: null, selectedSubItem: '' });
    if (path === '/digital') this.setState({ expanded: 'ai', selectedSubItem: '' });
  }

  findExpandedKey = (section, content) => {
    if (
      [
        content.submenuAbout,
        content.submenuGame,
        content.submenuZalo,
        content.submenuZaloPay,
        content.submenuDB,
        content.submenuVNGPS,
        content.submenuVNGATCRS,
      ].includes(section)
    ) return 'message';

    if (
      [
        content.submenu2024Highlight,
        content.submenuCorporateStructure,
        content.submenuMacroeconomicOverview,
      ].includes(section)
    ) return 'target';

    if (
      [
        content.submenuMDA,
        content.submenuAnalysis,
        content.submenuAssessment,
      ].includes(section)
    ) return 'report';

    return null;
  };

  handleMainSelect = (key, menuItems) => {
    const { onClose } = this.props;
  
    const foundItem = menuItems.find(item => item.key === key);
    if (foundItem && foundItem.sections) {
      this.setState({ expanded: this.state.expanded === key ? null : key });
      return;
    }
  
    if (onClose) onClose();
  
    const setAppState = StoreManager.appState.thisApp.setState.bind(StoreManager.appState.thisApp);
    let path = '/';
  
    switch (key) {
      case 'home':
        setAppState({ currentPage: 'HomeScreen' });
        path = '/';
        break;
      case 'ai':
        setAppState({ currentPage: 'DigitalTransformationScreen', subPageContent: 'DigitalTransformationContent' });
        path = '/digital';
        break;
      default:
        break;
    }
  
    window.history.pushState({}, '', path);
    this.setState({ expanded: null, selectedSubItem: '' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  

  handleSubSelect = (parentKey, section) => {
    const { onClose } = this.props;
    if (onClose) onClose();
  
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].AppLanguage;
    const setAppState = StoreManager.appState.thisApp.setState.bind(StoreManager.appState.thisApp);
    let page = 'AboutScreen';
    let subPage = '';
    let path = '/about';
  
    const mapping = {
      [content.submenuAbout]: { subPage: 'AboutContent', path: '/about' },
      [content.submenuGame]: { subPage: 'Game2024Content', path: '/about/game' },
      [content.submenuZalo]: { subPage: 'Zalo2024Content', path: '/about/zalo' },
      [content.submenuZaloPay]: { subPage: 'Zalopay2024Content', path: '/about/zalopay' },
      [content.submenuDB]: { subPage: 'DigitalBusiness2024Content', path: '/about/digital-business' },
      [content.submenuVNGPS]: { subPage: 'VNGPeopleStrategyContent', path: '/about/people-strategy' },
      [content.submenuVNGATCRS]: { subPage: 'VNGsApproachToCSRContent', path: '/about/csr' },
      [content.submenuDigitalTransformation]: { subPage: 'DigitalTransformationContent', path: '/digital' },

  
      [content.submenu2024Highlight]: { page: 'BusinessStrategyScreen', subPage: 'Highlight2024Content', path: '/strategy' },
      [content.submenuCorporateStructure]: { page: 'BusinessStrategyScreen', subPage: 'CorporateStructureContent', path: '/strategy' },
      [content.submenuMacroeconomicOverview]: { page: 'BusinessStrategyScreen', subPage: 'MacroeconomicOverviewContent', path: '/strategy' },
  
      [content.submenuMDA]: { page: 'ManagementReportScreen', subPage: 'ManagementReportContent1', path: '/report' },
      [content.submenuAnalysis]: { page: 'ManagementReportScreen', subPage: 'ManagementReportContent2', path: '/report' },
      [content.submenuAssessment]: { page: 'ManagementReportScreen', subPage: 'ManagementReportContent3', path: '/report' },
    };
  
    const target = mapping[section];
    if (target) {
      page = target.page || page;
      subPage = target.subPage;
      path = target.path || path;
    }
  
    setAppState({ currentPage: page, subPageContent: subPage });
    window.history.pushState({}, '', path);
    this.setState({ selectedSubItem: section });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  

  render() {
    const { expanded, selectedSubItem } = this.state;
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].AppLanguage;
    
    const menuItems = [
      { 
        key: 'home', 
        icon: resources.images.menu_icon1, 
        label: content.homePageName || 'Home', // Nếu muốn chắc chắn fallback
      },
      { 
        key: 'message', 
        icon: resources.images.menu_icon2, 
        label: content.aboutPageNameMenu || 'VNG 20 years legacy',
        sections: [
          content.submenuAbout,
          content.submenuGame,
          content.submenuZalo,
          content.submenuZaloPay,
          content.submenuDB,
          content.submenuVNGPS,
          content.submenuVNGATCRS,
        ]
      },
      { 
        key: 'ai', 
        icon: resources.images.menu_icon3, 
        label: content.digitalTransformationPageName || 'Digital transformation',
      },
      { 
        key: 'target', 
        icon: resources.images.menu_icon4, 
        label: content.businessStrategyPageName || 'Business strategy',
        sections: [
          content.submenu2024Highlight,
          content.submenuCorporateStructure,
          content.submenuMacroeconomicOverview,
        ]
      },
      { 
        key: 'report', 
        icon: resources.images.menu_icon5, 
        label: content.managementReportPageName || 'Management report',
        sections: [
          content.submenuMDA,
          content.submenuAnalysis,
          content.submenuAssessment,
        ]
      },
    ];
    
    return (
      <div style={{ padding: 24, backgroundColor: '#F7F3F0', height: '100%', overflowY: 'auto' }}>
        {menuItems.map((item) => (
          <div key={item.key}>
            <div
              onClick={() => this.handleMainSelect(item.key, menuItems)}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px 8px',
                borderRadius: 8,
                marginBottom: 8,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              <img
                src={item.icon}
                alt={item.label}
                style={{
                  width: 24,
                  height: 24,
                  marginRight: 12,
                }}
              />
              <span style={{
                fontSize: 16,
                fontWeight: 500,
                color: '#E0582C',
              }}>
                {item.label}
              </span>
            </div>

            {/* Submenu */}
            {expanded === item.key && item.sections && (
              <div style={{ paddingLeft: 36, marginTop: 4 }}>
                {item.sections.map((section, idx) => {
                  const isSelected = section === selectedSubItem;
                  return (
                    <div
                      key={idx}
                      onClick={() => this.handleSubSelect(item.key, section)}
                      style={{
                        fontSize: 16,
                        fontWeight: 500,
                        color: isSelected ? '#F15A24' : '#1A1A1A',
                        marginBottom: 8,
                        cursor: 'pointer',
                        borderBottom: isSelected ? '1px solid #F15A24' : 'none',
                        width: 'fit-content',
                      }}
                    >
                      {section}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default MobileMenu;
